import {
  locationIdFormat,
  storageLocationIdFormat,
} from "@redotech/redo-model/ids";
import { StorageLocationTypeSchema } from "@redotech/redo-model/wms/schema/storage-location";
import * as z from "zod/v4";

export const createStorageLocations = {
  name: "createStorageLocations" as const,
  input: z.object({
    names: z.array(z.string().min(1)).min(1, "At least one name is required"),
    locationId: locationIdFormat.schema,
    type: StorageLocationTypeSchema,
  }),
  output: z.object({
    storageLocationIds: z.array(storageLocationIdFormat.schema),
    errors: z.array(z.object({ name: z.string(), error: z.string() })),
  }),
};

export type CreateStorageLocationsInput = z.infer<
  typeof createStorageLocations.input
>;

export {
  BinTableLocationTypes,
  StorageLocationType,
} from "@redotech/redo-model/wms/schema/storage-location";
